import { useQuery } from "@tanstack/react-query";
import type { AdminOrderPaymentResponse } from "@/lib/api/types";
import { endpoints } from "@/lib/api/endpoints";
import { apiJsonClient } from "@/lib/query/core/api-json-client";
import { queryKeys } from "@/lib/query/core/query-keys";

type Params = {
  storeId: string;
  orderId: string;
};

// The latest online-payment transaction for an order (null for COD/manual).
export function useStoreOrderPaymentTransactionQuery({
  storeId,
  orderId,
}: Params) {
  const query = useQuery({
    queryKey: queryKeys.admin.storeOrderPaymentTransaction(storeId, orderId),
    queryFn: () =>
      apiJsonClient<AdminOrderPaymentResponse>(
        endpoints.admin.storeOrderPaymentTransaction(storeId, orderId),
      ),
    enabled: storeId.length > 0 && orderId.length > 0,
  });

  return { transaction: query.data?.transaction ?? null };
}
